// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3H3PF","name":"Header_name__1ENRJ","birthday":"Header_birthday__2O4jr","skeleton":"Header_skeleton__DNrLI"};